import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { PartyPopper, Calendar } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

interface CongratsWizardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateLesson: () => void;
}

export const CongratsWizardModal: React.FC<CongratsWizardModalProps> = ({ isOpen, onClose, onCreateLesson }) => {
  const { t } = useLanguage();

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto w-16 h-16 rounded-full bg-gradient-to-br from-primary to-primary/60 flex items-center justify-center mb-3">
            <PartyPopper className="h-8 w-8 text-primary-foreground" />
          </div>
          <DialogTitle className="text-center text-xl">
            {t('wizard.congrats.title') || 'Félicitations !'}
          </DialogTitle>
          <DialogDescription className="text-center pt-2">
            {t('wizard.congrats.subtitle') || 'Vous avez paramétré votre compte. Vous êtes prêt à créer votre premier cours.'}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="flex-col sm:flex-row gap-2 mt-2">
          <Button variant="ghost" onClick={onClose} className="sm:flex-1">
            {t('wizard.congrats.later') || 'Plus tard'}
          </Button>
          <Button onClick={onCreateLesson} className="sm:flex-1 gap-2">
            <Calendar className="h-4 w-4" />
            {t('wizard.congrats.createLesson') || 'Créer mon 1er cours'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CongratsWizardModal;
